export default __webpack_public_path__ + "static/media/cwSuiteLogo.ee86eded.png";